/* global Blockly */
import React from 'react';
import MobiControlCore from './MobiControlCore';

function defineBlock(context) {
    let prop = {...context};
    prop.blockText = "get device MAC address";
    prop.tooltipText = "Get MAC address from MobiControl.";
    prop.responseText = "MAC address";
    prop.responseBlockType = "text_response";
    let blockInstance = MobiControlCore(prop);
    return blockInstance;
}

function defineGenerators() {
    return {
        'JavaScript': function (block) {
            let coreResponseCode = block.getJavascriptCore();
            return `Snap.mcDeviceDetails.getMACAddress(${coreResponseCode});\n`;
        }
    }
}

const MobiControlGetMacAddress = function (props) {
    const name = 'snap_mobicontrol_getmacaddress';
    MobiControlGetMacAddress.blockName = name;

    Blockly.Blocks[name] = defineBlock(props.context);
    let generators = defineGenerators(props.context);
    for (let i in generators) {
        Blockly[i][name] = generators[i];
    }

    return <block type={name}></block>;
}

export default MobiControlGetMacAddress;